import { Button, ButtonProps } from "@mui/material";
import useDataset from "~/pages/datasets/hooks/useDataset";
import { DatasetAccessLevel } from "~/pages/datasets/types/enums/access-level";
import { trackEvent } from "~/utils/monitoring";

interface LineageButtonProps {
  onOpenLineage: () => void;
  analyticsContext?: {
    dataset_id?: string;
    table_fqn?: string;
  };
  analyticsEvent?: string;
  size?: ButtonProps["size"];
  sx?: ButtonProps["sx"];
}

export function LineageButton({
  onOpenLineage,
  analyticsContext,
  analyticsEvent = "lineage_button_clicked",
  size,
  sx,
}: LineageButtonProps) {
  const { data: dataset } = useDataset();

  // Only show lineage button to dataset owners (or in non-dataset contexts)
  if (dataset && dataset.access_level !== DatasetAccessLevel.OWNER) {
    return null;
  }

  const handleClick = () => {
    if (analyticsContext) {
      trackEvent(analyticsEvent, analyticsContext);
    }
    onOpenLineage();
  };

  return (
    <Button
      variant="outlined"
      size={size}
      sx={sx}
      onClick={handleClick}
      data-testid="view-lineage-button"
    >
      View Lineage
    </Button>
  );
}
